import script from "./ContainerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerDetails.vue?vue&type=script&setup=true&lang=js"

import "./ContainerDetails.vue?vue&type=style&index=0&id=4ff1d194&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff1d194"]])

export default __exports__